import { useTranslation } from "next-i18next";
import { FC } from "react";
import { BeatLoader } from "react-spinners";

import Trans from "~/types/translationKeys";
import styles from "./ButtonLoadMore.module.scss";

interface ButtonLoadMoreProps {
  page: number;
  page_count: number;
  handleLoadMore: () => void;
  loading: boolean;
}

const ButtonLoadMore: FC<ButtonLoadMoreProps> = ({
  page,
  page_count,
  handleLoadMore,
  loading,
}) => {
  const { t } = useTranslation();

  if (page >= page_count && !loading) {
    return null;
  }

  return (
    <div
      className={styles.button_load_more}
      onClick={() => !loading && handleLoadMore()}
    >
      {loading ? <BeatLoader color="#364de7" size={10} /> : t(Trans.load_more)}
    </div>
  );
};

export default ButtonLoadMore;
